import React from 'react';
import LogCannon from '@ace-clublabs/log-cannon';
import { Route, Switch, useLocation } from 'react-router';
import { Pages } from '@lib/types';
import { SorryPage } from '../containers/SorryPage';
import { ContactDetailsPage } from '../containers/ContactDetailsPage';
import { AddressPage } from '../containers/AddressPage';
import { ReviewPage } from '../containers/ReviewPage';
import { BuildMembershipPage } from '../containers/BuildMembershipPage';
import { AddAssociatePage } from '../containers/AddAssociatePage';
import { ConfirmationPage } from '../containers/ConfirmationPage';
import { BenefitsPage } from '../containers/BenefitsPage';
import { AutopayPage } from '../containers/AutopayPage';
import { LandingPage } from '../containers/LandingPage';
import { CreateMembershipStatusPage } from '../containers/CreateMembershipStatusPage';
import { AdditionalBenefitsPage } from '../containers/AdditionalBenefitsPage';
import { DateSelector } from '../containers/DateSelector';
import { MemberExistsPage } from '../containers/MemberExistsPage';
import { SendGiftCardPage } from '../containers/SendGiftCardPage';
import { GiftRecipientClubMismatch } from '../containers/GiftRecipientClubMismatch';
import { GiftDonorContactPage } from '../containers/GiftDonorContactPage';
import { GiftDonorAddressPage } from '../containers/GiftDonorAddressPage';
import { SendMembershipCardPage } from '../containers/SendMembershipCardPage';
import { KnockoutPage } from '../containers/KnockoutPage';
import PartnerEnrollmentPage from '../containers/PartnerEnrollmentPage';
import { MaintenancePage } from '../containers/MaintenancePage';
import { AutoCompleteAddressPage } from '../containers/AutoCompleteAddressPage';
import { StatelessConfirmationPage } from '../containers/StatelessConfirmationPage';

function usePageViews() {
  let location = useLocation();
  React.useEffect(() => {
    LogCannon.blast(`Navigate to ${location.pathname}`, {
      pathname: location.pathname,
      search: location.search,
    });
  }, [location]);
}

const Router: React.FC = () => {
  usePageViews();

  return (
    <Switch>
      <Route path={Pages.SorryPage} component={SorryPage} />
      <Route path={Pages.ContactDetailsPage} component={ContactDetailsPage} />
      <Route path={Pages.ResidenceAddressPage} component={() => <AddressPage addressType="residence" />} />
      <Route path={Pages.MailingAddressPage} component={() => <AddressPage addressType="mailing" />} />
      <Route
        path={Pages.AutoCompleteResidenceAddressPage}
        component={() => <AutoCompleteAddressPage addressType="residence" />}
      />
      {/* <Route
        path={Pages.AutoCompleteMailingAddressPage}
        component={() => <AutoCompleteAddressPage addressType="mailing" />}
      /> */}
      <Route path={Pages.ReviewPage} component={ReviewPage} />
      <Route path={Pages.BuildMembershipPage} component={BuildMembershipPage} />
      <Route path={Pages.AddAssociatePage} component={AddAssociatePage} />
      <Route path={Pages.ConfirmationPage} component={ConfirmationPage} />
      <Route path={Pages.StatelessConfirmationPage} component={StatelessConfirmationPage} />
      <Route path={Pages.BenefitsPage} component={BenefitsPage} />
      <Route path={Pages.AutopayPage} component={AutopayPage} />
      <Route path={Pages.LandingPage} component={LandingPage} />
      <Route path={Pages.CreateMembershipStatusPage} component={CreateMembershipStatusPage} />
      <Route path={Pages.AdditionalBenefitsPage} component={AdditionalBenefitsPage} />
      <Route path={Pages.DateSelector} component={DateSelector} />
      <Route path={Pages.MemberExists} component={MemberExistsPage} />
      <Route path={Pages.GiftDonorContactPage} component={GiftDonorContactPage} />
      <Route path={Pages.SendGiftCardPage} component={SendGiftCardPage} />
      <Route path={Pages.GiftRecipientClubMismatchPage} component={GiftRecipientClubMismatch} />
      <Route path={Pages.GiftDonorAddressPage} component={GiftDonorAddressPage} />
      <Route path={Pages.SendMembershipCardPage} component={SendMembershipCardPage} />
      <Route path={Pages.PartnerEnrollment} component={PartnerEnrollmentPage} />
      <Route path={Pages.MaintenancePage} component={MaintenancePage} />
      <Route exact path={Pages.VoucherStatus} component={() => <KnockoutPage errorType="voucherError" />} />
      <Route exact path={Pages.PartnerMemberExists} component={() => <KnockoutPage errorType="memberExists" />} />
      <Route exact path={Pages.OfferNotAvailable} component={() => <KnockoutPage errorType="InvalidGrouponStates" />} />
    </Switch>
  );
};

export default Router;
